<div class="outer-container">
  <span class="currentStatusTitile">Menu</span>
  <!--<span class="close" (click)="closeStatusPopup()">X</span>-->
  <div class="console-container">
    <div class="input-wrapper">
      <p class="set-status">Your Status has been set to "{{ selectedStatus ? selectedStatus.status : '' }}"</p> 
      <div class="row">
      <div class="col-5 status-label">Change Status</div> 
         <div class="col-7">
          <select [(ngModel)]="selectedStatus" (ngModelChange)="statusChange()" name="status">
            <ng-container *ngFor="let item of statusList">
              <option [ngValue]="item" class="option">
                {{ item.status }}
              </option> </ng-container
            >
          </select>
        </div> 
        <!-- <div class="underline-fixed" ></div> -->
      </div>
       <div *ngIf="isTimerRequired" class="row text-center">
        <p [class.display]="isTimedOut">{{ display }}</p>
      </div>
      <div class="row">
        <div class="options" (click)="onResumeCall()">
          <span
            ><img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-resume-call.svg" />Resume Calling</span
          >
        </div>
        <div *ngIf="showChangeQueue" class="options" (click)="onChangeQueue()" >
          <span
            ><img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-change-queue.svg" />Change Queue
          </span>
        </div>
        <div class="options" (click)="onPerformance()">
          <span
            ><img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-performance_menu.svg" />Performance</span
          >
        </div>
        <div class="options" (click)="onVoicemail()">
          <span><img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-voicemail.svg" />Voicemails</span>
        </div>
        <div class="options" (click)="onLogout()">
          <span><img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-logout.svg" />Log Out</span>
        </div>
      </div>
    </div>
    <div class="bottom-line" *ngIf="ShowOkButton"></div> 
      <!--<div class="text-center" *ngIf="ShowOkButton">
      <button class="main-btn mt-3">
        <span (click)="bsModalRef.hide()" >Ok</span>-->
      <!-- <button class="submitBtn"> -->
      <!-- <span class="submitOkBtn" (click)="bsModalRef.hide()">Ok</span> -->
      <!--</button>
    </div>-->
    </div>
  </div>